
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.383 15.767L22 14.17v-4.043l-3.617-1.594.426-3.93-3.5-2.02-3.189 2.336-3.19-2.336-3.502 2.02.43 3.93-3.618 1.594v4.043l3.617 1.597-.429 3.927 3.501 2.023 3.191-2.336 3.188 2.336 3.501-2.023-.426-3.927z","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.12 15.706a3.556 3.556 0 100-7.112 3.556 3.556 0 000 7.112z","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    